import React from 'react'
import JsonLd from '@atoms/JsonLd/JsonLd'

const JsonLdWrapper = ({
  data
}: {
  data: any
  regions: Array<any>
  custom?: any
}) => {
  return (
    <JsonLd
      type={data?.type}
      object={data?.data ? JSON.parse(data?.data) : {}}
    />
  )
}

export default JsonLdWrapper
